var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"パスワードリセット","description":"ご登録のメールアドレスにパスワードリセットのご案内をお送りしました。\nメールの内容に沿ってパスワードをリセットしてください。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }